import React from 'react';
import TextField from '@mui/material/TextField';
import { useField } from 'formik';

export const EditDetails = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <TextField
      fullWidth
      multiline
      rows={10}
      variant="outlined"
      label={label}
      helperText={meta.touched && meta.error}
      error={meta.touched && !!meta.error}
      {...field}
      {...props}
    />
  );
};
